import React, { useState } from 'react';
export function FAQSection() {
  const faqs = [{
    q: 'How do I get the material?',
    a: 'Instant download link via email after purchase. 100% digital high-res PDF.'
  }, {
    q: 'Can I use it on my tablet during practice?',
    a: 'Yes. Optimized for mobile and tablet for immediate on-ice reference.'
  }, {
    q: 'Is it suitable for high-performance?',
    a: 'Absolutely. Modeled after top-tier professional coaching standards.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-brand-dark py-32 px-4 border-t border-brand-border" data-id="element-66">
      <div className="max-w-4xl mx-auto" data-id="element-67">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-16" data-id="element-68">
          ❓ FREQUENTLY ASKED{' '}
          <span className="text-brand-accent" data-id="element-69">QUESTIONS</span>
        </h2>
        <div className="space-y-4" data-id="element-70">
          {faqs.map((faq, i) => <div key={i} className="bg-brand-card rounded-2xl border border-brand-border overflow-hidden" data-id="element-71">
              <button className="w-full px-8 py-6 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent hover:bg-white/5 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-72">
                <span className="font-bold text-white text-lg pr-8" data-id="element-73">
                  <span className="text-brand-accent mr-2" data-id="element-74">{i + 1} —</span>{' '}
                  {faq.q}
                </span>
                <span className={`text-brand-accent text-2xl flex-shrink-0 transition-transform duration-300 leading-none ${openIndex === i ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-75">
                  ▾
                </span>
              </button>
              {openIndex === i && <div role="region" data-id="element-76">
                  <div className="px-8 pb-8 text-white/80 border-t border-brand-border pt-6 text-lg leading-relaxed" data-id="element-77">
                    {faq.a}
                  </div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}